import {Box, Center, Text} from '@chakra-ui/react'
import VideoCustom from './VideoCustom'

const Situation = () => {
  return (
    <Box mt={'60px'}>
      <Box bg={'#000'} h={{base: '260px', md: '550px'}}>
        <Center w={'100%'} maxW={'900px'} h={'100%'} mx={'auto'}>
          <VideoCustom
            isIntro={true}
            px={{base: '16px', md: '60px'}}
            py="24px"
            fontSize="24px"
          />
        </Center>
      </Box>
      <Text fontSize={'16px'} color={'#8C8C8C'} mt={'24px'} align={'center'}>
        Cố gắng nghe hết nha bạn!
      </Text>
    </Box>
  )
}

export default Situation
